import React, { useEffect, useRef, useState } from 'react'
import logo from "../assets/img/logo_img.png"
import "./footer.css"
import { hidePrivateService, hideSectionBanner, hideTeamInfoPanel, hideTeamsMenu, toggleHeroService } from '../features/serviceSlice'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLegalExpanded, setIsLegalExpanded] = useState(false);
  const legalCopyRef = useRef(null);

  useEffect(() => {
    setIsLegalExpanded(false);
  }, [location.pathname]);

  useEffect(() => {
    const collapseLegalCopy = () => setIsLegalExpanded(false);

    window.addEventListener("blacklabel:collapse-footer-legal", collapseLegalCopy);
    return () => {
      window.removeEventListener("blacklabel:collapse-footer-legal", collapseLegalCopy);
    };
  }, []);

  useEffect(() => {
    if (!isLegalExpanded) return;

    const scrollTimer = setTimeout(() => {
      legalCopyRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 60);

    return () => clearTimeout(scrollTimer);
  }, [isLegalExpanded]);

  return (
    <>
      <div className='d-flex-space footer-container'>
        <p className="footer-legal-copy" ref={legalCopyRef}>
          <button
            className="footer-legal-toggle"
            type="button"
            aria-expanded={isLegalExpanded}
            onClick={() => setIsLegalExpanded((expanded) => !expanded)}
          >
            © 2026 Sudsies, Inc. All rights reserved.
          </button>
          {isLegalExpanded ? (
            <span className="footer-legal-details">
              {" "}All trademarks, logos and brand names are the property of their respective owners. Use of these names, trademarks and brands does not imply endorsement.
            </span>
          ) : null}
        </p>
        <img onClick={() => {
          dispatch(toggleHeroService())
          dispatch(hideSectionBanner())
          dispatch(hideTeamsMenu())
          dispatch(hideTeamInfoPanel())

          dispatch(hidePrivateService())
          setTimeout(() => {
            navigate(`/`)
          }, 800)
        }} src={logo} alt="" />
      </div>
    </>
  )
}

export default Footer
